import React from 'react';
import {Mixin as FormsyMixin} from 'formsy-react';
import ReactDOMServer from 'react-dom/server';

import './JavaScriptEditor.scss';

const JavaScriptEditor = React.createClass({
    // Add the Formsy Mixin
    mixins: [FormsyMixin],

    getInitialState() {
        return {
            height: 300,
            loaded: false,
            fullscreen: false
        };
    },

    componentDidMount() {
        import(/* webpackChunkName: "brace" */ 'brace').then((val) => {
            let ace = val.default;

            Promise.all([import(/* webpackChunkName: "react-ace" */ 'react-ace'), import(/* webpackChunkName: "brace-searchbox" */ 'brace/ext/searchbox'), import(/* webpackChunkName: "brace-javascript" */ 'brace/mode/javascript'), import(/* webpackChunkName: "brace-github" */ 'brace/theme/github'), import(/* webpackChunkName: "brace-monokai" */ 'brace/theme/monokai'), import(/* webpackChunkName: "brace-github" */ 'brace/ext/language_tools')]).then((values) => {
                this.AceEditor = values[0].default;

                let langTools = ace.acequire('ace/ext/language_tools');
                /* your custom completer */
                let customCompleter = {
                    //eslint-disable-next-line max-params
                    getCompletions: (editor, session, pos, prefix, callback) => {
                        let globals = this.getGlobals();

                        if (!globals) {
                            callback(null, []);
                            return;
                        }

                        callback(null, Object.keys(this.getGlobals()).map(function(word) {
                            return {
                                caption: word,
                                value: word,
                                meta: "static"
                            };
                        }));
                    }
                };
                langTools.addCompleter(customCompleter);

                this.setState({
                    loaded: true
                });
            }).catch(() => {});
        }).catch(() => {});

        this.escHandler = (e) => {
            if (e.keyCode === 27 && this.state.fullscreen) { // esc key code
                e.preventDefault();

                this.toggleFullscreen();
            }
        };

        document.addEventListener("keydown", this.escHandler, false);
    },

    componentWillUnmount() {
        document.removeEventListener("keydown", this.saveAction, false);

        if (this.observer && this.observer.disconnect) {
            this.observer.disconnect();
        }

        if (this.scrollInterval) {
            clearInterval(this.scrollInterval);
        }
    },

    // setValue() will set the value of the component, which in
    // turn will validate it and the rest of the form
    changeValue(value) {
        this.setValue(value);
        this.props.onChange(this.props.name, value);
        this.changeDimensions();
    },

    getKey() {
        return window.location.href + '#' + this.props.name;
    },

    getStoredHeight() {
        let dimensions = window.localStorage.getItem('javascriptFields');

        if (!dimensions) {
            return 300;
        }

        try {
            let dimensionsObject = JSON.parse(dimensions);

            if (dimensionsObject && dimensionsObject[this.getKey()]) {
                return dimensionsObject[this.getKey()];
            }
        }
        catch (e) {
            return 300;
        }
    },

    getStoredAceSettingsJSON() {
        let aceSettings = window.localStorage.getItem('aceEditorSettings');

        if (!aceSettings) {
            return {};
        }

        try {
            let aceSettingsParsed = JSON.parse(aceSettings);

            if (aceSettingsParsed) {
                return aceSettingsParsed;
            }
        }
        catch (e) {
            return {};
        }
    },

    storeHeigth(height) {
        // storing via timeout to prevent excess accessing of local store during resizing event
        if (this.storingTimeout) {
            window.clearTimeout(this.storingTimeout);
        }

        this.storingTimeout = setTimeout(() => {
            if (this.state.fullscreen) {
                return;
            }

            let dimensions = window.localStorage.getItem('javascriptFields');

            if (!dimensions) {
                dimensions = {};
            }
            else {
                dimensions = JSON.parse(dimensions);
            }

            dimensions[this.getKey()] = height;

            window.localStorage.setItem('javascriptFields', JSON.stringify(dimensions));
        }, 100);
    },

    onLoad() {
        setTimeout(() => {
            this.changeDimensions();

            if (this.editor) {

                if (this.observer) {
                    this.observer.disconnect();
                }

                let height = this.editor.style.height;

                this.observer = new MutationObserver((mutationsList, observer) => {
                    for (let mutation of mutationsList) {
                        if (mutation.type === 'attributes') {
                            let heightNow = this.editor.style.height;

                            if (height !== heightNow) {
                                let height = this.changeDimensions();

                                this.storeHeigth(height);
                            }
                        }
                    }
                }).observe(this.editor, {attributes: true});
            }
        }, 10);
    },

    changeDimensions() {
        if (this.editor) {
            if (!this.editorEl) {
                this.editorEl = this.editor.querySelector('.ace_editor');
            }

            if (!this.scrollEl) {
                this.scrollEl = this.editor.querySelector('.ace_scrollbar-v .ace_scrollbar-inner');
            }

            let height = parseInt(this.scrollEl.style.height.split('px')[0], 10);
            let minHeight = this.editor.style.height ? parseInt(this.editor.style.height.split('px')[0], 10) : 300;

            if (height < minHeight) {
                height = minHeight;
            }

            this.editorEl.style.height = '' + height + 'px';
            this.setState({
                height: height
            });

            return minHeight;
        }

        return 300;
    },

    getGlobals() {
        if (!this.props.globalVariables) {
            return null;
        }

        return {
            'console': 'logger',
            'Buffer': 'Buffer',
            'moment': 'moment',
            'Math': 'Math',
            'fetch': 'fetch(args)',
            'crypto': 'crypto',
            'JSON': 'JSON',
            'xml2js': 'async xml2js(string) : Object',
            'XLSX': 'XLSX',
            'js2xml': 'js2xml',
            'csv2js': 'async csv2js(buffer, options)',
            'js2csv': 'async js2csv(buffer, options)',
            'FormData': 'FormData',
            'user': 'user {email, firstname, surname}',
            'request': 'request(args)',
            'require': 'require(name)',
            'output': 'output',
            'perfMark': 'perfMark(id)',
            'notifyByEmail': 'notifyByEmail(to: String[], subject: String, htmlBody: String)',
            'notifyAdmin': 'notifyAdmin(subject: String, htmlBody: String)',
            'matchJsonPath': 'matchJsonPath(jsonPath: String, json: Object)',
            'removeAccents': 'removeAccents(string: String)',
            'bigDecimal': 'bigDecimal.divide()',
            'convertVATtoCode': 'convertVATtoCode(country: string, vat: number, date: Date, base: number, tax: number, total: number)',
            'variableResolver': 'variableResolver(string, options)',
            ...this.props.globalVariables,
        };
    },

    showGlobalVariables() {
        let allGlobals = this.getGlobals();

        if (!allGlobals) {
            return null;
        }

        return (
            <small><small>
                <span>
                {Object.keys(allGlobals).sort().map((key, idx) => {
                        let desc = allGlobals[key];

                        let sep = idx > 0 ? ', ' : '';

                        return <span key={key} title={desc}>{sep}<code>{key}</code></span>;
                    })}
                </span>
            </small></small>
        );
    },

    //eslint-disable-next-line max-params
    completion(editor, session, caretPosition2d, prefix, callback) {
        let globals = this.getGlobals();

        let returnValues = Object.keys(globals)
            .filter((item) => item.startsWith(prefix))
            .sort((itemA, itemB) => itemA.localeCompare(itemB))
            .map((item) => ({name: item, value: name, score: 1, meta: '', description: globals[item], parameters: null, returnType: ''}));

            // debugger;

        callback(null, returnValues);
        //
        //
        //
        // debugger;
        //
        // callback(null, );
        //
        // const suggestions = this.expressionSuggester.suggestionsFor(this.state.value, caretPosition2d)
        // callback(null, _.map(suggestions, (s) => {
        // 	//unfortunately Ace treats `#` as special case, we have to remove `#` from suggestions or it will be duplicated
        // 	//maybe it depends on language mode?
        // 	const methodName = s.methodName.replace("#", "")
        // 	const returnType = ProcessUtils.humanReadableType(s.refClazz)
        // 	return {name: methodName, value: methodName, score: 1, meta: returnType, description: s.description, parameters: s.parameters, returnType: returnType}
        // }))
    },

    getDocTooltip(item) {
        if (item.description) {
            item.docHTML = ReactDOMServer.renderToStaticMarkup((
                <div className="function-docs">
                    <p>{item.description}</p>
                </div>
            ));
        }
    },

    toggleFullscreen() {
        this.setState({
            fullscreen: !this.state.fullscreen
        });

        setTimeout(() => {
            if (this.editor && this.editor.querySelector && this.editor.querySelector('textarea')) {
                this.editor.querySelector('textarea').focus();
            }
        }, 10);
    },

    render() {
        // Set a specific className based on the validation
        // state of this component. showRequired() is true
        // when the value is empty and the required prop is
        // passed to the input. showError() is true when the
        // value typed is invalid
        const className = 'form-group row ' + (this.props.className || ' ') +
          (this.showRequired() ? 'required' : this.showError() ? 'error' : '');

        // An error message is returned ONLY if the component is invalid
        // or the server has returned an error message
        const errorMessage = this.getErrorMessage();

        let component = null;

        if (this.state.loaded) {
            component = (<this.AceEditor
                enableLiveAutocompletion
                height={'' + this.state.height + 'px'}
                highlightActiveLine
                minLines={4}
                mode="javascript"
                name={this.props.name}
                onChange={this.changeValue}
                onCursorChange={(editor, event) => {
                    setTimeout(() => {
                        if (!this.cursor) {
                            this.cursor = this.editor.querySelector('.ace_cursor');
                        }

                        if (this.cursor && this.cursor.scrollIntoViewIfNeeded) {
                            this.cursor.scrollIntoViewIfNeeded();
                        }
                    }, 99);
                }}
                onLoad={() => {this.onLoad();}}
                setOptions={{
                    wrapBehavioursEnabled: true,
                    vScrollBarAlwaysVisible: true,
                    displayIndentGuides: true,
                    enableSnippets: false,
                }}
                showPrintMargin={false}
                theme={this.getStoredAceSettingsJSON().theme || "github"}
                type={this.props.type || 'text'}
                value={this.getValue() || ''}
                width="100%"
                wrapEnabled
            />);
        }

        return (
          <div className={className + " java-script-editor"}>
            <label className="control-label col-sm-3" htmlFor={this.props.name}>{this.props.label}</label>
            <div className={"col-sm-9" + (this.state.fullscreen ? " fullscreen" : '')}>
                <div className={this.state.fullscreen ? " fullscreen" : ''} >
                    <div className="resizabe" ref={(el) => {this.editor = el;}} style={{height: this.getStoredHeight()}}>
                        {component}
                        <a className="fullscreenToggle" onClick={() => { this.toggleFullscreen(); }}><i className={"fa " + (this.state.fullscreen ? 'fa-compress' : 'fa-expand')}></i></a>
                    </div>
                    {this.showGlobalVariables()}
                </div>
            </div>
            <span className='validation-error'>{errorMessage}</span>
          </div>
        );
    }
});

export default JavaScriptEditor;
